import { render, staticRenderFns } from "./PlaceModal.vue?vue&type=template&id=25c13c0b&scoped=true&"
import script from "./PlaceModal.vue?vue&type=script&lang=js&"
export * from "./PlaceModal.vue?vue&type=script&lang=js&"
import style0 from "./PlaceModal.vue?vue&type=style&index=0&id=25c13c0b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c13c0b",
  null
  
)

export default component.exports